import React from 'react';
import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';
import jsPDF from 'jspdf';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    setAllActiveLayersPrintable
} from '../../../../redux/active_layers/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import withStyles from '@material-ui/core/styles/withStyles';
import ScrollableContainer from '../../../utility/ScrollableContainer';
import BaseLayers from './BaseLayers';
import Layers from './Layers';
import SizeSettings from './SizeSettings';
import { PDFIcon } from '../../../UI/icons';
import {
    TextField,
    Typography,
    FormControlLabel as MuiFormControlLabel,
    Checkbox,
    Collapse,
    Button,
    Modal,
    RadioGroup,
    Radio,
    Snackbar,
    FormControl,
    InputLabel,
    Input,
    Select,
    ListItemText,
    MenuItem
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CircularProgress from '@material-ui/core/CircularProgress';

import PreviewMapImage from './PreviewMapImage';
import PDFTemplate from './PDFTemplateProvider';
import PDFInfoForm from './PDFInfoForm';
import _ from 'lodash';
import PrintMap from './PrintMap';
import PrintMiniMap from './PrintMiniMap';

const FormControlLabel = withStyles((theme) => ({
    root: {
        marginRight: '0px'
    },
    label: {
        color: theme.palette.grey.variant5,
        fontSize: '12px'
    }
}))(MuiFormControlLabel);

function setDefaultCentrePoint (drawModule, highlightedFeatures) {
    if (drawModule) {
        const drawnFeatures = drawModule.getDrawControl().getSelected();
        if (drawnFeatures && drawnFeatures.features.length > 0) {
            return 'drawnArea';
        }
    }
    if (highlightedFeatures.highlightedFeatures.length > 0) {
        return 'selectedSite';
    }
    return 'mapView';
}

function debounce (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

class PrintPanel extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
        const { user, drawModule, highlights } = this.props;
        this.setDisplayedImage = this.setDisplayedImage.bind(this);
        this.setFormData = this.setFormData.bind(this);
        this.allLayersOn = this.allLayersOn.bind(this);
        this.toggleSelectAllLayers = this.toggleSelectAllLayers.bind(this);
        this.exportPDF = this.exportPDF.bind(this);
        this.setSelectedSites = this.setSelectedSites.bind(this);
        this.setSelectedDrawnAreas = this.setSelectedDrawnAreas.bind(this);

        this.state = {
            isExporting: false,
            mapSettingsDropdown: true,
            displayedClientImage: '',
            displayedCompanyImage: '',
            formData: {
                author: `${user.firstName} ${user.lastName}`,
                reference: '',
                basemap: 'light',
                check: 'Unchecked',
                date: (new Date()).toLocaleDateString('en-UK'),
                epsg: 'N/A',
                clientLogo: '',
                companyLogo: '',
                paper: 'a3',
                scale: '2500',
                subtitle: '',
                title: '',
                centrePoint: setDefaultCentrePoint(drawModule, highlights),
                redLineBoundaryVisible: true,
                mySiteCardsVisible: false
            },
            errorFields: [],
            errorMessage: '',
            acceptTerms: false,
            mapImage: '',
            fitBounds: null,
            aspect: null,
            downloading: false,
            selectedSites: highlights.highlightedFeatures.find(f => f.key.includes('_selected')) ?
                [...highlights.highlightedFeatures.find(f => f.key.includes('_selected')).features] : [],
            selectedDrawnAreas: [...this.props.selectedDrawnFeatures] || []
        };
    }

    componentDidUpdate (prevProps, prevState) {
        if (prevProps.open !== this.props.open) {
            const { highlights, selectedDrawnFeatures, drawModule } = this.props;
            this.setState({
                selectedSites: highlights.highlightedFeatures.find(f => f.key.includes('_selected')) ?
                    [...highlights.highlightedFeatures.find(f => f.key.includes('_selected')).features] : [],
                selectedDrawnAreas: [...selectedDrawnFeatures] || [],
                centrePoint: setDefaultCentrePoint(drawModule, highlights),
                date: (new Date()).toLocaleDateString('en-UK')
            });
        }
    }

    setFormData (key, value, resetMap = false) {
        const { errorFields } = this.state;
        // ! Need to debounce due to map changes will be incredibly annoying
        const run = debounce(() => {
            if (resetMap) {
                this.setState({
                    formData: {
                        ...this.state.formData,
                        [key]: value
                    },
                    mapImage: ''
                });
            } else {
                this.setState({
                    formData: {
                        ...this.state.formData,
                        [key]: value
                    },
                    errorFields: errorFields.includes(key) ? errorFields.filter(f => f !== key) : errorFields
                });
            }
        }, 250, true);
        run();
    }

    setDisplayedImage (e, type) {
        let reader = new FileReader();
        let panel = this;
        reader.onload = function (e) {
            panel.setState({
                [type]: e.target.result
            });
            panel.setFormData(type === 'displayedClientImage' ? 'clientLogo' : 'companyLogo', e.target.result );
        };
        reader.readAsDataURL(e.target.files[0]);
    }

    allLayersOn () {
        const { activeLayers, selectedDrawnFeatures, highlights, drawModule } = this.props;
        const { formData } = this.state;
        const selectedHighlight = highlights.highlightedFeatures.find(f => f.key.includes('_selected')) ?
            highlights.highlightedFeatures.find(f => f.key.includes('_selected')) : null;
        const drawnFeatures = drawModule ? drawModule.getDrawControl().getSelected().features : [];
        const visibleLayers = [drawnFeatures.length > 0, ...activeLayers.map(l => l.visible)].filter(l => l);
        const allLayers = [drawnFeatures.length > 0, ...activeLayers.map(l => l.printable && l.visible)].filter(l => l);
        return { visibleLayers: visibleLayers.length, allLayers: allLayers.length };
    }

    toggleSelectAllLayers () {
        const { dispatchSetAllActiveLayersPrintable, activeLayers, selectedDrawnFeatures, highlights } = this.props;
        const visibleLayersCount = this.allLayersOn().allLayers;
        const selectedHighlight = highlights.highlightedFeatures.find(f => f.key.includes('_selected')) ?
            highlights.highlightedFeatures.find(f => f.key.includes('_selected')) : null;
        if (visibleLayersCount < (activeLayers.length + (selectedDrawnFeatures.length > 0 || !_.isEmpty(selectedHighlight)) ? 1 : 0)) {
            // set all to true
            dispatchSetAllActiveLayersPrintable(true);
            this.setFormData('redLineBoundaryVisible', true);
        } else {
            // set all to false
            dispatchSetAllActiveLayersPrintable(false);
            this.setFormData('redLineBoundaryVisible', false);
        }
    }

    // Converts from mm to pixels
    // Used to set the width and height of map HTML elements
    toPixels (length) {
        return ((96 / 25.4) * length) + 'px';
    }

    exportPDF () {
        const {
            formData,
            acceptTerms,
            mapImage,
            minimapImage,
            errorMessage
        } = this.state;
        const errors = [];
        if (!acceptTerms) { errors.push('acceptTerms'); }
        if (!mapImage /* || !minimapImage */) {
            errors.push('mapLoading');
            return this.setState({ errorMessage: 'Wait for map to finish loading.' });
        }
        if (!formData.subtitle) { errors.push('subtitle'); }
        if (!formData.title) { errors.push('title'); }
        if (!formData.author) { errors.push('author'); }
        if (!formData.check) { errors.push('check'); }

        if (errors.length > 0) {
            this.setState({
                errorFields: errors,
                errorMessage: 'Some required fields are missing.',
                isExporting: false
            });
            return;
        } else {
            this.setState({
                errorMessage: '',
                isExporting: true
            });
        }




        const pdf = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: formData.paper,
            compress: true
        });

        let hidden = document.createElement('div');
        // hidden.className = 'hidden-map';
        hidden.style.overflow = 'hidden';
        hidden.style.height = '0';
        hidden.style.width = '0';
        hidden.style.position = 'fixed';
        document.body.appendChild(hidden);
        let container = document.createElement('div');
        container.style.width = this.toPixels(pdf.internal.pageSize.width);
        container.style.height = this.toPixels(pdf.internal.pageSize.height);
        hidden.appendChild(container);


        const baseLayer = this.props.baseLayers.find(bl => bl.system_name === 'light');
        // The main map is already ready and cached so just load the minimap
        ReactDOM.render(
            <PrintMiniMap
                onImageReady={(image) => {
                    this.exportPDFAsync(image);
                    ReactDOM.unmountComponentAtNode(container);
                    hidden.parentNode.removeChild(hidden);
                }}

                style={baseLayer.styling.mapbox}
                width={512}
                height={256}
                fitBounds={this.state.mapFitBounds}
            />,
            container
        );
    }

    exportPDFAsync = (minimapImage) => {

        const { formData } = this.state;

        const pdf = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: formData.paper,
            compress: true
        });

        let hidden = document.createElement('div');
        // hidden.className = 'hidden-map';
        hidden.style.overflow = 'hidden';
        hidden.style.height = '0';
        hidden.style.width = '0';
        hidden.style.position = 'fixed';
        document.body.appendChild(hidden);
        let container = document.createElement('div');
        container.style.width = this.toPixels(pdf.internal.pageSize.width);
        container.style.height = this.toPixels(pdf.internal.pageSize.height);
        hidden.appendChild(container);

        ReactDOM.render(
            <PDFTemplate
                formData={formData}
                stopDownloading={() => {
                    this.setState({
                        isExporting: false
                    });
                    ReactDOM.unmountComponentAtNode(container);
                    hidden.parentNode.removeChild(hidden);
                }}
                mapImage={this.state.mapImage}
                minimapImage={minimapImage}
                layers={this.props.layers}
                baseLayers={this.props.baseLayers}
                baseLayer={this.props.baseLayer}
                selectedDrawnFeatures={this.props.selectedDrawnFeatures}
            />,
            container
        );
    };

    setSelectedSites (e) {
        this.setState({
            selectedSites: e.target.value,
            // To re-render the map
            mapImage: ''
        });
    }

    setSelectedDrawnAreas (e) {
        this.setState({
            selectedDrawnAreas: e.target.value,
            // To re-render the map
            mapImage: ''
        });
    }

    handleMainMapImageLoaded = (image, fitBounds) => {
        this.setState({
            mapImage: image,
            mapFitBounds: fitBounds
        });
    };

    render () {
        const { classes, activeLayers, drawModule, highlights, selectedDrawnFeatures, open, setOpen, user } = this.props;
        const {
            isExporting,
            mapSettingsDropdown,
            displayedClientImage,
            displayedCompanyImage,
            formData,
            errorFields,
            acceptTerms,
            mapImage,
            minimapImage,
            downloading,
            errorMessage,
            selectedSites,
            selectedDrawnAreas
        } = this.state;
        const visibleLayerCount = this.allLayersOn();
        const selectedHighlight = highlights.highlightedFeatures.find(f => f.key.includes('_selected')) ?
            highlights.highlightedFeatures.find(f => f.key.includes('_selected')) : null;
        const highlightedFeatures = selectedHighlight ?
            selectedHighlight.features : [];
        const redLineBoundaryEnabled = (selectedDrawnFeatures.length > 0 || !_.isEmpty(selectedHighlight));

        const pdf = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: formData.paper,
            compress: true
        });

        return (
            <>
                <Modal
                    id="print-modal"
                    open={open}
                    onClose={(e) => {
                        // Resetting details on close
                        this.setState({
                            isExporting: false,
                            mapSettingsDropdown: false,
                            formData: {
                                author: `${user.firstName} ${user.lastName}`,
                                reference: '',
                                basemap: 'light',
                                check: 'Unchecked',
                                date: (new Date()).toLocaleDateString('en-UK'),
                                epsg: 'N/A',
                                clientLogo: '',
                                companyLogo: '',
                                paper: 'a3',
                                scale: '2500',
                                subtitle: '',
                                title: '',
                                centrePoint: 'mapView',
                                redLineBoundaryVisible: true,
                                mySiteCardsVisible: false
                            },
                            errorFields: [],
                            errorMessage: '',
                            acceptTerms: false,
                            mapImage: '',
                            downloading: false,
                            selectedSites: [],
                            selectedDrawnAreas: []
                        });
                        setOpen(false);
                    }}
                >
                    <div className={classes.body}>
                        <div className={classes.formContainer}>
                            <div className={classes.titleContainer}>
                                <Typography
                                    variant="h2"
                                    color="textPrimary"
                                    className={classes.title}
                                >
                                    Map Export
                                </Typography>
                            </div>
                            <div className={`${classes.container} ${classes.flexGrow}`}>
                                <ScrollableContainer className={classes.scrollableContainer}>
                                    <div className={classes.innerContainer}>
                                        <PDFInfoForm
                                            formData={formData}
                                            setFormData={this.setFormData}
                                            setDisplayedImage={this.setDisplayedImage}
                                            displayedClientImage={displayedClientImage}
                                            displayedCompanyImage={displayedCompanyImage}
                                            errorFields={errorFields}
                                        />
                                    </div>
                                    <div
                                        className={classes.mapSettingsTitle}
                                        onClick={(e) => this.setState({ mapSettingsDropdown: !mapSettingsDropdown })}
                                    >
                                        <Typography
                                            variant="subtitle2"
                                            component="div"
                                            color="textPrimary"
                                            className={classes.subtitle}
                                        >
                                            Map Settings
                                        </Typography>
                                        <KeyboardArrowDownIcon
                                            htmlColor="#8C9799"
                                            className={`${classes.dropdownButtonArrow} ${mapSettingsDropdown && classes.inverted}`}
                                        />
                                    </div>
                                    <div className={classes.innerContainer}>
                                        <Collapse in={mapSettingsDropdown}>
                                            <SizeSettings
                                                scale={formData.scale}
                                                setScale={(scale) => this.setFormData('scale', scale, true)}
                                                paperSize={formData.paper}
                                                setPaperSize={(size) => this.setFormData('paper', size, true)}
                                            />
                                            <div className={classes.mapPositionContainer}>
                                                <Typography
                                                    gutterBottom
                                                    className={classes.mapPositionHeader}
                                                >
                                                    Map Position
                                                </Typography>
                                                <RadioGroup
                                                    className={classes.mapPositionGrid}
                                                    value={formData.centrePoint}
                                                    onChange={(e) => this.setFormData('centrePoint', e.target.value, true)}
                                                >
                                                    <FormControlLabel
                                                        value="mapView"
                                                        control={<Radio />}
                                                        label="Map View"
                                                    />
                                                    <FormControlLabel
                                                        disabled={highlightedFeatures.length === 0}
                                                        value="selectedSite"
                                                        control={<Radio />}
                                                        label="Selected Site"
                                                    />
                                                    <FormControlLabel
                                                        disabled={drawModule && selectedDrawnFeatures.length === 0}
                                                        value="drawnArea"
                                                        control={<Radio />}
                                                        label="Drawn Area"
                                                    />
                                                </RadioGroup>
                                            </div>
                                            {/* Commented out below for ease at moment but should be re-added */}
                                            {/* { (formData.centrePoint === 'selectedSite' && highlightedFeatures.length > 1) && (
                                                <div>
                                                    <FormControl className={classes.selectedSiteFormControl}>
                                                        <InputLabel>Selected Sites</InputLabel>
                                                        <Select
                                                            multiple
                                                            fullWidth
                                                            variant="outlined"
                                                            value={selectedSites}
                                                            input={<Input/>}
                                                            renderValue={(selected) => selected.map((s) => s.featureId).join(', ')}
                                                            onChange={this.setSelectedSites}
                                                        >
                                                            { highlightedFeatures.map((f) => (
                                                                <MenuItem key={f.featureId} value={f}>
                                                                    <Checkbox
                                                                        checked={selectedSites.filter((s) => s.featureId === f.featureId).length > 0}
                                                                    />
                                                                    <ListItemText primary={f.featureId} />
                                                                </MenuItem>
                                                            )) }
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            ) } */}
                                            {/* { (formData.centrePoint === 'drawnArea' && selectedDrawnFeatures.length > 1) && (
                                                <div>
                                                    <FormControl className={classes.selectedSiteFormControl}>
                                                        <InputLabel>Drawn Areas</InputLabel>
                                                        <Select
                                                            multiple
                                                            fullWidth
                                                            variant="outlined"
                                                            value={selectedDrawnAreas}
                                                            input={<Input/>}
                                                            renderValue={(selected) => selected.map((s, i) => `Feature ${i}`).join(', ')}
                                                            onChange={this.setSelectedDrawnAreas}
                                                        >
                                                            { [ ...selectedDrawnFeatures ].map((f, i) => (
                                                                <MenuItem key={f.id} value={f}>
                                                                    <Checkbox
                                                                        checked={selectedDrawnAreas.filter((s) => s.id === f.id).length > 0}
                                                                    />
                                                                    <ListItemText primary={`Feature ${i}`} />
                                                                </MenuItem>
                                                            )) }
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            ) } */}
                                            <div className={classes.mapPositionContainer}>
                                                <div className={classes.visibleLayersTitle}>
                                                    <Typography
                                                        className={classes.mapPositionHeader}
                                                        gutterBottom={(activeLayers.length + selectedDrawnFeatures.length) === 0}
                                                    >
                                                        Visible Layers
                                                    </Typography>
                                                    { (activeLayers.length + (redLineBoundaryEnabled ? 1 : 0)) > 0 &&
                                                        <FormControlLabel
                                                            control={<Checkbox
                                                                // + 1 to account for the red line boundary box checked
                                                                checked={visibleLayerCount.allLayers !== 0 && visibleLayerCount.allLayers === (activeLayers.length +
                                                                    ((redLineBoundaryEnabled && formData.redLineBoundaryVisible) ? 1 : 0))}
                                                                indeterminate={visibleLayerCount.allLayers !== 0 && visibleLayerCount.allLayers !== (activeLayers.length +
                                                                    ((redLineBoundaryEnabled && formData.redLineBoundaryVisible) ? 1 : 0))}
                                                                onClick={this.toggleSelectAllLayers}
                                                            />}
                                                            label={`Show All (${visibleLayerCount.visibleLayers})`}
                                                            labelPlacement="start"
                                                            className={classes.showAllLayersLabel}
                                                        />
                                                    }
                                                </div>
                                                <Layers
                                                    redLineBoundaryVisible={formData.redLineBoundaryVisible}
                                                    setRedLineBoundaryVisible={(visible) => this.setFormData('redLineBoundaryVisible', visible, true)}
                                                    mySiteCardsVisible={formData.mySiteCardsVisible}
                                                    setMySiteCardsVisible={(visible) => this.setFormData('mySiteCardsVisible', visible, true)}
                                                    renderMap={() => this.setState({ mapImage: '' })}
                                                />
                                            </div>
                                            <BaseLayers
                                                basemap={formData.basemap}
                                                changeBasemap={(layer) => this.setFormData('basemap', layer, true) }
                                            />
                                        </Collapse>
                                    </div>
                                    <div className={classes.toc}>
                                        <FormControlLabel
                                            control={<Checkbox
                                                checked={acceptTerms}
                                                onChange={(e) => this.setState({ acceptTerms: e.target.checked })}
                                            />}
                                            label={<Typography
                                                variant="caption"
                                                color="textPrimary"
                                                style={{ color: (errorFields.includes('acceptTerms') && !acceptTerms) && 'red' }}>
                                                By clicking, you agree to our terms and conditions
                                            </Typography>}
                                        />
                                    </div>
                                </ScrollableContainer>
                            </div>
                            <div className={classes.buttonsContainer}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.exportButton}
                                    disabled={!acceptTerms || downloading || isExporting}
                                    onClick={this.exportPDF}
                                >
                                    { isExporting ? 'EXPORTING' : 'EXPORT AS PDF'}
                                </Button>
                                <Button
                                    variant="outlined"
                                    className={classes.cancelButton}
                                    onClick={(e) => setOpen(false)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </div>
                        <div className={classes.previewContainer}>
                            <div className={classes.previewInner} style={{ backgroundColor: !mapImage && 'rgb(0, 0, 0, 0.5)' }}>
                                <PrintMap
                                    height={pdf.internal.pageSize.height}
                                    width={pdf.internal.pageSize.width}
                                    scale={formData.scale}
                                    mapPosition={formData.centrePoint}
                                    baseLayer={formData.basemap}
                                    includeDrawnFeatures={formData.redLineBoundaryVisible}
                                    includeSiteCards={formData.mySiteCardsVisible}
                                    onImageLoaded={this.handleMainMapImageLoaded}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <Snackbar
                        open={Boolean(errorMessage)}
                        autoHideDuration={6000}
                        onClose={() => this.setState({ errorMessage: '' })}
                    >
                        <Alert
                            onClose={() => this.setState({ errorMessage: '' })}
                            severity="error"
                            variant="filled"
                            elevation={6}
                        >
                            { errorMessage }
                        </Alert>
                    </Snackbar> */}
                </Modal>
            </>
        );
    }

}

const style = theme => ({
    body: {
        ['@media (max-width:1370px)']: {
            width: '900px',
            maxHeight: '600px',
            transform: 'translate(-450px, -300px)'
        },
        ['@media (min-width:1371px)']: {
            width: '1350px',
            maxHeight: '800px',
            transform: 'translate(-675px, -400px)'
        },
        position: 'absolute',
        top: '50%',
        left: '50%',
        display: 'grid',
        gridTemplateColumns: '400px auto',
        outline: 'none'
    },
    opacity: {
        opacity: 0.4
    },
    exportButton: {
        boxShadow: 'none',
        fontWeight: 700,
        width: '160px',
        letterSpacing: '1.25px',
        fontWeight: 500
    },
    loadingInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        height: '80px',
        width: '150px',
        ['@media (max-width:1370px)']: {
            top: 'calc(50% - 40px)',
            left: 'calc(50% + 125px)'
        },
        ['@media (min-width:1371px)']: {
            top: 'calc(50% - 40px)',
            left: 'calc(50% + 150px)'
        }
    },
    loadingText: {
        paddingTop: '10px',
        color: theme.palette.primary.contrastText
    },
    loadingIcon: {
        '& > svg': {
            color: theme.palette.primary.light
        }
    },
    mapPositionHeader: {
        color: theme.palette.grey.variant5,
        fontSize: '14px',
        letterSpacing: '0.4px',
        fontWeight: 500
    },
    mapPositionGrid: {
        display: 'grid',
        gridTemplateColumns: '50% 50%'
    },
    visibleLayersTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    showAllLayersLabel: {
        '& > label': {
            fontSize: '12px'
        }
    },
    cancelButton: {
        width: '160px',
        letterSpacing: '1.25px',
        fontWeight: 500
    },
    flexGrow: {
        flexGrow: 1
    },
    formContainer: {
        backgroundColor: theme.palette.background.dark,
        boxSizing: 'border-box',
        borderTopLeftRadius: '6px',
        borderBottomLeftRadius: '6px',
        display: 'flex',
        flexDirection: 'column'
    },
    previewContainer: {
        ['@media (max-width:1370px)']: {
            padding: '0 20px'
        },
        ['@media (min-width:1371px)']: {
        },
        backgroundColor: theme.palette.grey.variant2,
        borderTopRightRadius: '6px',
        borderBottomRightRadius: '6px',
        display: 'grid',
        placeItems: 'center'
    },
    previewInner: {
        ['@media (max-width:1370px)']: {
            minWidth: '400px',
            minHeight: '300px'
        },
        ['@media (min-width:1371px)']: {
            maxWidth: '850px'
        },
        background: theme.palette.primary.contrastText,
        boxShadow: '0 4px 4px rgb(0, 0, 0, 0.25)',
        padding: '12px',
        boxSizing: 'border-box'
    },
    previewImage: {

    },
    scrollableContainer: {
        ['@media (max-width:1370px)']: {
            maxHeight: '450px'
        },
        ['@media (min-width:1371px)']: {
            maxHeight: '650px'
        },
        '&::-webkit-scrollbar': {
            width: 8
        },
        '&::-webkit-scrollbar-track': {
            background: theme.palette.primary.main
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.palette.grey.variant5
        }
    },
    titleContainer: {
        borderBottom: '1px solid #505A5C'
    },
    innerContainer: {
        padding: '0 20px'
    },
    container: {
        borderBottom: '1px solid #505A5C'
    },
    buttonsContainer: {
        height: '76px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        columnGap: '10px',
        borderTop: '1px solid #505A5C'
    },
    mapSettingsTitle: {
        borderTop: '1px solid #505A5C',
        marginTop: '20px',
        height: '50px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px'
    },
    title: {
        fontSize: '22px',
        lineHeight: '76px',
        paddingLeft: '33px',
        textTransform: 'none'
    },
    subtitle: {
        fontSize: '14px',
        fontWeight: '500'
    },

    checkbox: {
        '&&:hover': {
            backgroundColor: 'transparent'
        }
    },
    dropdownContainer: {
        margin: '0 5px'
    },
    dropdownButton: {
        display: 'flex',
        color: theme.palette.background.contrastText,
        cursor: 'pointer',
        height: '40px',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.background.contrastText}`
    },
    dropdownButtonArrow: {
        transition: '0.25s'
    },
    inverted: {
        transform: 'rotate(180deg)'
    },
    divider: {
        borderBottom: '1px solid #505A5C'
    },
    confirmation: {
        marginTop: '10px'
    },
    highlighted: {
        color: theme.palette.secondary.main
    },
    price: {
        margin: '10px 5px 0 5px'
    },
    toc: {
        // margin: '10px 5px 0 5px',
        padding: '10px 20px 10px 20px',
        borderTop: '1px solid #505A5C'
    },
    confirmButton: {
        paddingTop: '10px'
    },
    error: {

    },
    selectedSiteFormControl: {
        width: '100%',
        padding: '10px 0'
    },
    mapPositionContainer: {
        marginBottom: '10px'
    }
});

const mapStateToProps = state => {
    return {
        user: state.user,
        baseLayers: state.layers.baseLayers,
        activeLayers: state.activeLayers,
        drawModule: state[MAIN_MAP].drawModule,
        selectedDrawnFeatures: (state[MAIN_MAP].drawModule) ? state[MAIN_MAP].drawModule.getDrawControl().getSelected().features : [],
        highlights: state.highlights,
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchSetAllActiveLayersPrintable: (value) => dispatch(setAllActiveLayersPrintable(value))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(PrintPanel);